// @flow
import React from 'react';
import ConnectViewer from 'app/common/react/components/common/ConnectViewer/ConnectViewer';
import DidItProfileFeed from 'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItProfileFeed';
import type { CommentUser } from 'app/packages/pinterest-flow-types/user';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';
import withRouteData from 'app/common/lib/react/withRouteData';
import { compose } from 'redux';
import withResource, { type Resource } from 'app/common/lib/react/withResource';

type Props = {
  userResource: Resource<CommentUser>,
  params: { username: string },
};
function DidItProfileFeedContainer({ userResource, params }: Props) {
  return userResource.data ? (
    <ConnectViewer>
      {(viewer: Viewer) => (
        <DidItProfileFeed
          isOwnProfile={viewer.username ? viewer.username === params.username : false}
          triedItUser={userResource.data}
        />
      )}
    </ConnectViewer>
  ) : null;
}

export default compose(
  withRouteData({
    name: 'TriedItList',
    routeContextLog: () => ({
      view_type: PCONST.thrift.ViewType.USER,
      view_parameter: PCONST.thrift.ViewParameterType.USER_DID_IT,
    }),
  }),
  withResource({
    name: 'UserResource',
    key: 'userResource',
    options: ({ params }) => ({
      field_set_key: 'profile',
      username: params.username,
    }),
  }),
)(DidItProfileFeedContainer);
